
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DetailDialog from '@/components/busi/table/detail.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { subjectSearch, subjectDetail } from '@/api/baseinformation'
@Component({
  name: 'major-manage',
  components: {
    SimpleTable,
    DetailDialog,
    DictSelect
  }
})
export default class MajorManage extends Vue {
  private form = {
    subjectState: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'subjectCode',
    label: '专业代码'
  },
  {
    prop: 'subjectName',
    label: '专业名称'
  },
  {
    prop: 'degreeName',
    label: '学历层次'
  },
  {
    prop: 'lenName',
    label: '学制'
  },
  {
    prop: 'subjectState',
    label: '状态'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    // do something
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await subjectSearch({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      subjectState: 1
    }
    this.onQuery()
  }

  private visible = !1

  private detailData = {}

  private async showDetail (row: any) {
    await subjectDetail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !0
        this.detailData = {
          subjectCode: res.object.subjectCode,
          subjectName: res.object.subjectName,
          degreeName: res.object.degreeName,
          lenName: res.object.lenName
        }
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
